import React from 'react';
import { Button } from '../ui/button';

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-20 bg-[#0A0E27]">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#0066FF]/20 to-[#00D9FF]/20 rounded-3xl blur-xl" />
            <img
              src="https://images.unsplash.com/photo-1761330440311-16e160cad236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxzcGxpdCUyMGFpciUyMGNvbmRpdGlvbmVyJTIwbW9kZXJuJTIwaG9tZXxlbnwwfHx8fDE3NzA0NzUyODJ8MA&ixlib=rb-4.1.0&q=85"
              alt="Modern Split Air Conditioner in Luxury Home"
              className="relative rounded-2xl shadow-2xl border border-white/10"
            />
          </div>
          <div className="space-y-6">
            <span className="inline-block bg-[#0066FF]/20 text-[#00D9FF] px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider">
              About Us
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white">
              About Chill Point
            </h2>
            <p className="text-base text-gray-400 leading-relaxed">
              Chill Point is your dedicated local refrigeration and air conditioning specialist serving Ballito and the North Coast. We pride ourselves on attention to detail, safety-first practices, and providing long-term solutions instead of temporary fixes.
            </p>
            <p className="text-base text-gray-400 leading-relaxed">
              Our approach is simple: accurate diagnostics, honest advice, and quality workmanship. We don't guess - we use professional fault-finding techniques to identify the real issue and fix it right the first time.
            </p>
            <p className="text-base text-gray-400 leading-relaxed">
              Whether you need routine maintenance, emergency repairs, or new installations, we're committed to keeping your home or business comfortable all year round — cooling in summer, heating in winter.
            </p>
            <div className="flex items-center space-x-4 pt-4">
              <Button size="lg" className="bg-gradient-to-r from-[#0066FF] to-[#00D9FF] hover:from-[#0052CC] hover:to-[#00B8D4] text-white font-bold shadow-lg shadow-blue-500/25">
                <a href="#contact">Get in Touch</a>
              </Button>
              <a href="tel:0644505026" className="text-[#00D9FF] font-semibold hover:text-white transition-colors">
                Call: 064 450 5026
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
